import { environment } from '@/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map } from 'rxjs';
import { handleError } from '../tools/handle-error.tools';
import { EstadisticaCategoria } from '@/app/models/interface/estadistica-categoria.model';
import {
  PaginatorModel,
  HasPagination,
} from '@/app/models/interface/paginator.model';
import { CustomResponse } from '@/app/models/interface/response.model';

@Injectable({ providedIn: 'root' })
export class EstadisticaCategoriaService {
  private readonly http = inject(HttpClient);
  private readonly url = environment.api + 'estadistica-categoria/';

  create(data: Partial<EstadisticaCategoria>) {
    return this.http
      .post<CustomResponse<EstadisticaCategoria>>(this.url, data)
      .pipe(
        catchError((err) => handleError(err)),
        map((data) => {
          const d = data.result;
          return d;
        }),
      );
  }

  findAll(params?: HttpParams) {
    return this.http
      .get<
        CustomResponse<PaginatorModel<EstadisticaCategoria[], HasPagination>>
      >(this.url, {
        params,
      })
      .pipe(
        catchError((err) => handleError(err)),
        map((data) => {
          const d = data.result;
          return d;
        }),
      );
  }

  findOne(id: number) {
    const url = this.url + id;
    return this.http.get<CustomResponse<EstadisticaCategoria>>(url).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        return {
          ...d,
        };
      }),
    );
  }

  update(tipo: Partial<EstadisticaCategoria>) {
    const url = this.url + tipo.id;
    return this.http.put<CustomResponse<EstadisticaCategoria>>(url, tipo).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        return {
          ...d,
        };
      }),
    );
  }

  changeState(state: boolean, id: number) {
    const url = this.url + id;
    return this.http
      .patch<CustomResponse<EstadisticaCategoria>>(url, { state })
      .pipe(
        catchError((err) => handleError(err)),
        map((data) => {
          const d = data.result;
          return {
            ...d,
          };
        }),
      );
  }
}
